import script from "./RedirectToSelect.vue?vue&type=script&lang=js"
export * from "./RedirectToSelect.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__